import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["UNSAFE_onScrollRelease", "UNSAFE_onScrollEnd", "UNSAFE_onScrollStart", "UNSAFE_onScroll", "controlsRef", "domNodeRef"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { useDragRef } from "../../../utils/react-spring";
import withScrollClickSuppression from "./withScrollClickSuppression";
var RELEASE_VELOCITY = 300;

/**
 * HOC that enables drag behavior for scroll container
 */
export default function withDragScroll(WrappedScrollContainer) {
  function DragScrollContainer(_ref) {
    var UNSAFE_onScrollRelease = _ref.UNSAFE_onScrollRelease,
      UNSAFE_onScrollEnd = _ref.UNSAFE_onScrollEnd,
      UNSAFE_onScrollStart = _ref.UNSAFE_onScrollStart,
      UNSAFE_onScroll = _ref.UNSAFE_onScroll,
      controlsRef = _ref.controlsRef,
      domNodeRef = _ref.domNodeRef,
      otherProps = _objectWithoutProperties(_ref, _excluded);
    /** decipher controls */
    var scrollTo = function scrollTo() {
      var _controlsRef$current;
      return (_controlsRef$current = controlsRef.current).scrollTo.apply(_controlsRef$current, arguments);
    };
    var stopScroll = function stopScroll() {
      return controlsRef.current.stopScroll();
    };
    var getScroll = function getScroll() {
      return controlsRef.current.getScroll();
    };

    /** Attach drag handler */
    useDragRef(function (_ref2) {
      var first = _ref2.first,
        last = _ref2.last,
        movement = _ref2.movement,
        vxvy = _ref2.vxvy,
        _ref2$memo = _ref2.memo,
        initialScroll = _ref2$memo === void 0 ? getScroll() : _ref2$memo;
      var currentScroll = initialScroll - movement[0];
      function callScrollHandler(scrollHandler) {
        if (scrollHandler) scrollHandler({
          movement: movement,
          vxvy: vxvy,
          current: currentScroll,
          initial: initialScroll
        });
      }
      if (last) {
        if (vxvy[0]) {
          /** simulate momentum scroll */
          scrollTo(currentScroll - vxvy[0] * RELEASE_VELOCITY);
          callScrollHandler(UNSAFE_onScrollRelease);
        } else {
          callScrollHandler(UNSAFE_onScrollEnd);
        }
      } else {
        scrollTo(currentScroll, {
          immediate: true
        });
        if (first) {
          callScrollHandler(UNSAFE_onScrollStart);
        } else {
          callScrollHandler(UNSAFE_onScroll);
        }
      }
      return initialScroll;
    }, {
      domTarget: domNodeRef
    });
    function handleHorizontalWheel(event) {
      if (Math.abs(event.deltaX) > 2) stopScroll();
    }
    return /*#__PURE__*/React.createElement(WrappedScrollContainer, _extends({}, otherProps, {
      controlsRef: controlsRef,
      domNodeRef: domNodeRef,
      onMouseDown: stopScroll,
      onWheel: handleHorizontalWheel,
      "data-t-id": "ScrollContainerV2-enhancers"
    }));
  }
  DragScrollContainer.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread(_objectSpread({}, WrappedScrollContainer.propTypes), {}, {
    /** settings props */
    // isLocked: PropTypes.bool,
    // isDraggable: PropTypes.bool,

    /**
     * Following handlers only work with drag behavior,
     * and may change in the future - use at your own risk
     */
    UNSAFE_onScroll: PropTypes.func,
    UNSAFE_onScrollStart: PropTypes.func,
    UNSAFE_onScrollRelease: PropTypes.func,
    UNSAFE_onScrollEnd: PropTypes.func
  }) : {};
  if (process.env.NODE_ENV !== 'production') {
    DragScrollContainer.displayName = 'DragScrollContainer';
  }
  return withScrollClickSuppression(DragScrollContainer);
}